import apiConfig from "constants/apiConfig"
import { SocialAccountContentFilters, SocialAccountCreatorsFilters, TrackedPostsFilters } from "types/social-account";
import axiosClient from "utils/axiosClient"

export const initIGConnection = async (agencyId: string, social_account_id: string | null=null, feature: string | null = null) => {
    const response = await axiosClient.get(apiConfig.INIT_IG_CONNECTION.url.replace('<agencyId>', agencyId), {params: {...(feature ? {feature} : {}), ...(social_account_id ? {social_account_id} : {})}});
    return response.data;
}

export const submitAccessToken = async (agencyId: string, access_token: string) => {
    const response = await axiosClient.post(apiConfig.SUBMIT_ACCESS_TOKEN_FOR_IG_CONNECT.url.replace('<agencyId>', agencyId), {access_token});
    return response.data;
}  

export const fetchConnectedIGAccounts = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.LIST_CONNECTED_IG_ACCOUNTS.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const linkIGAccount = async (agencyId: string, igAccountId: string, via: string = 'fb') => {
    const response = await axiosClient.get(apiConfig.LINK_IG_ACCOUNT.url.replace('<agencyId>', agencyId).replace('<accountId>', igAccountId));
    return response.data;
}

export const fetchSocialAccounts = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNTS.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const fetchSocialAccount = async (agencyId: string, socialAccountId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId));

    return response.data;
}

export const fetchSocialPostComments = async (agencyId: string, socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST_COMMENTS.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId));
    return response.data.items ?? [];
}

export const deleteSocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string) => {
    const response = await axiosClient.delete(apiConfig.DELETE_SOCIAL_POST_COMMENTS.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId));
    return response.data;
}

export const replySocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string, message: string) => {
    const response = await axiosClient.post(apiConfig.REPLY_SOCIAL_POST_COMMENT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId), {message});
    return response.data;
}

export const replyPrivatelySocialPostComment = async (agencyId: string, socialAccountId: string, socialPostId: string, commentId: string, message: string) => {
    const response = await axiosClient.post(apiConfig.REPLY_PRIVATELY_SOCIAL_POST_COMMENT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId).replace('<socialPostId>', socialPostId).replace('<commentId>', commentId), {message});
    return response.data;
}

export const fetchTrackedPosts = async (agencyId: string, social_account_id: string, filters: TrackedPostsFilters) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNT_TRACKED_POSTS.url.replace('<agencyId>', agencyId), {params: {...filters, social_account_id}});
    return response.data;
}

export const attachTrackedPostToCampaign = async (agencyId: string, trackedPostId: string, campaign_id: number) => {
    const response = await axiosClient.post(apiConfig.ATTACH_TRACKED_POST_TO_CAMPAIGN.url.replace('<agencyId>', agencyId).replace('<trackedPostId>', trackedPostId), { campaign_id });
    return response.data;
}

export const addSocialAccount = async (agencyId: string, data: any) => {
    const response = await axiosClient.post(apiConfig.ADD_SOCIAL_ACCOUNT.url.replace('<agencyId>', agencyId), data);
    return response.data;
}

export const enableMediaTracking = async (agencyId: string, socialAccountId: string) => {
    const response = await axiosClient.post((apiConfig.ENABLE_MEDIA_TRACKING.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId)));
    return response.data;
}

export const refreshTrackedMedia = async (agencyId: string, socialAccountId: string) => {
    const response = await axiosClient.post(apiConfig.REFRESH_TRACKED_MEDIA.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId));
    return response.data;
}

export const fetchSocialAccountCreators = async (agencyId: string, socialAccountId: string, filters: SocialAccountCreatorsFilters) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNT_CREATORS.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId), {params: {...filters}});
    return response.data;
}

export const fetchSocialAccountContent = async (agencyId: string, socialAccountId: string, filters: SocialAccountContentFilters) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_ACCOUNT_CONTENT.url.replace('<agencyId>', agencyId).replace('<socialAccountId>', socialAccountId), {params: {...filters}});
    return response.data;
}

export const fetchSocialProfiles = async (agencyId: string, platform: string, handles: string[]) => {
    const response = await axiosClient.post(apiConfig.FETCH_SOCIAL_PROFILES.url.replace('<agencyId>', agencyId), {platform, handles});
    return response.data;
}